import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "video-display" }
const _hoisted_2 = {
  key: 0,
  class: "camera-unavailable-placeholder"
}
const _hoisted_3 = {
  key: 1,
  class: "video-label"
}

import { ref, watch, onMounted, nextTick } from 'vue'

interface Props {
  stream: MediaStream | null
  label?: string
  mirrored?: boolean
  muted?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VideoDisplay',
  props: {
    stream: {},
    label: {},
    mirrored: { type: Boolean, default: false },
    muted: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const containerRef = ref<HTMLDivElement>()

async function attachStream(stream: MediaStream | null) {
  if (!containerRef.value) return

  // Clean up container when stream is removed
  if (!stream) {
    containerRef.value.innerHTML = ''
    console.log('[VideoDisplay] Cleared container (null stream)')
    return
  }

  const isZoomStream = (stream as any).__isZoomStream

  if (isZoomStream) {
    const zoomClient = (stream as any).__zoomClient
    const userId = (stream as any).__userId

    if (!zoomClient) {
      console.error('[VideoDisplay] Zoom client not found in stream')
      return
    }

    try {
      await nextTick()
      console.log(`[VideoDisplay] Attaching Zoom video (userId=${userId ?? 'local'})`)

      // ZoomClient.attachVideo() handles startVideo() + attachVideo(userId, quality)
      // and appends the SDK-managed <video> element into the container div.
      await zoomClient.attachVideo(containerRef.value, userId, {
        muted: props.muted,
        mirrored: props.mirrored,
      })

      console.log('[VideoDisplay] Successfully attached Zoom video')
    } catch (error) {
      console.error('[VideoDisplay] Failed to attach Zoom video:', error)
    }
  } else {
    // Standard WebRTC MediaStream — create a video element and set srcObject
    containerRef.value.innerHTML = ''
    const videoEl = document.createElement('video')
    videoEl.autoplay = true
    videoEl.playsInline = true
    videoEl.muted = props.muted
    if (props.mirrored) videoEl.style.transform = 'scaleX(-1)'
    videoEl.style.width = '100%'
    videoEl.style.height = '100%'
    videoEl.style.objectFit = 'cover'
    videoEl.srcObject = stream
    containerRef.value.appendChild(videoEl)
    console.log('[VideoDisplay] Attached WebRTC stream')
  }
}

watch(
  () => props.stream,
  (newStream) => {
    attachStream(newStream)
  },
  { immediate: true }
)

onMounted(() => {
  if (props.stream) {
    attachStream(props.stream)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "containerRef",
      ref: containerRef,
      class: "video-container video-player-container"
    }, null, 512),
    (!__props.stream && __props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "placeholder-icon" }, "📷", -1),
          _createElementVNode("p", { class: "placeholder-text" }, "Camera unavailable", -1)
        ]))]))
      : _createCommentVNode("", true),
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})